import IAppStore from "./IAppStore";
import TraderConfiguration from "features/settings/traders/traderConfiguration";
import ProducerConfiguration from "features/settings/producers/producerConfiguration";
import UserState from "features/login/userState";
import ApiProgress from "features/saveIndicator/apiProgress";
import HedgingConfiguration from "features/settings/hedging/hedgingConfiguration";
import  PositionSettingConfiguration  from "features/settings/longshort/positionSettingConfiguration";

const userState = new UserState();

const initialState: IAppStore = {
	userState: userState,
	userPermissions: null,
	offers: {},
	offerColumnConfigurations: null,
	traders: null,
	traderConfiguration: new TraderConfiguration(),
	producers: null,
	producerConfiguration: new ProducerConfiguration(),
	locations: null,
	positionGroups: null,
	apiProgress: new ApiProgress(),
	myCommodities: null,
	allCommodities: null,
	deliveryMethods: null,
	exchanges: null,
	commodityConfiguration: null,
	offerings: null,
	producerBulkUploadResponse: null,
	hedgingSettings: null,
	hedgingConfiguration: new HedgingConfiguration(),
	fcmAccounts: null,
	positionSettings: null,
	positionSettingConfiguration: new PositionSettingConfiguration(),
	deliveryPeriods: null,
	cropYears: null,
	futuresContractPrices: {},
	pageFilter: null,
	bidEditorDisablePeriods: null,
	futuresContractSubscriptions: [],
	deliveryPeriodsBulkUploadResponse: null,
	contracts: {},
	contractColumnConfigurations: null,
	positionBalances: null,
	positionHedges: [],
	stateProvinces: [],
	merchantFees: null,
	customFields: null,
	
	notifications: { notifications: [], totalCount: 0, unreadCount: 0},
	errorAlerts: null,

	allMerchants: [],
	systemConfig: null,
	marketSchedule: null,
	marketHolidays: null,
	featureFlags: null,
	userPreferenceCollection: null,
	currencies: null,
	units: null,
	unitsConversionRates: null,
	paymentOptionsDetails: null,
};

export default initialState;
